export var groupItems = function (columns) {
    var groupedListItems = [];
    columns.forEach(function (column) {
        if (column.group) {
            var itemIdx = groupedListItems.findIndex(function (q) { return 'groupName' in q && q.groupName === column.group; });
            if (itemIdx !== -1) {
                var group = groupedListItems[itemIdx];
                group.columns.push(column);
                groupedListItems[itemIdx] = group;
            }
            else {
                groupedListItems.push({
                    groupName: column.group,
                    columns: [column],
                });
            }
        }
        else {
            groupedListItems.push(column);
        }
    });
    return groupedListItems;
};
export function isGroupItem(item) {
    return 'groupName' in item;
}
//# sourceMappingURL=utils.js.map